import React from 'react'
import RenewalTracking from './RenewalTracking';

export default function MemberTracking() {
  return (
    <div>
        <RenewalTracking/>
    </div>
  )
}
